// VideoChatRemote.js
import React, { useContext } from 'react';
import { WebRTCContext } from './contexts/WebRTCContext';

export default function VideoChatRemote() {
  const {
    localVideoRef,
    remoteVideoRef,
    roomIdInputRef,
    roomId,
    handleOpenMedia,
    handleOpenAudioOnly,
    joinRoom,
    hangUp
  } = useContext(WebRTCContext);

  return (
    <div style={{ padding: '1rem', border: '1px solid #ccc', margin: '1rem', backgroundColor: '#cfcfcf' }}>
      <h2>Video Chat</h2>
      <div>
        <button onClick={handleOpenMedia}>Open Video Camera</button>
        <button onClick={handleOpenAudioOnly}>Open Audio Only</button>
        <button onClick={() => joinRoom(roomIdInputRef.current.value)}>Join Room</button>
        <input type="text" ref={roomIdInputRef} placeholder="Enter Room ID" />
        <button onClick={hangUp}>Hang Up</button>
      </div>
      <div>
        <video ref={localVideoRef} autoPlay playsInline muted style={{ width: '300px', border: '1px solid #000' }} />
        <video ref={remoteVideoRef} autoPlay playsInline style={{ width: '300px', border: '1px solid #000' }} />
      </div>
      {roomId && <p>Current Room ID: {roomId}</p>}
    </div>
  );
}